import Text from 'components/shared/Text'
import { useIntl } from 'react-intl'
import { formatPrice } from 'helpers/helpers'
import { Color, TextVariant } from 'styles/types'
import { Wrapper } from './styles'

interface PriceProps {
    value: number | null
    description?: string
    per?: 'person' | 'couple'
    color?: Color
    isCapitalized?: boolean
    size?:
        | 'heading1'
        | 'heading2'
        | 'heading3'
        | 'heading4'
        | 'body'
        | 'bodyStrong'
        | 'bodySmallStrong'
        | 'bodyExtraSmall'
    currencySize?: TextVariant
    descriptionSize?: TextVariant
    crossedOutVariant?: 'gray' | 'yellow'
    isNegative?: boolean
}

const Price = ({
    value,
    per,
    description,
    color,
    isCapitalized,
    crossedOutVariant,
    size = 'heading3',
    isNegative,
    currencySize,
    descriptionSize,
}: PriceProps) => {
    const { formatMessage } = useIntl()

    let descriptionVariant: TextVariant = 'bodySmall'
    let currencyVariant: TextVariant = crossedOutVariant
        ? size
        : currencySize || 'bodySmallStrong'

    switch (size) {
        case 'heading1':
            descriptionVariant = 'bodyLarge'
            currencyVariant = currencySize || 'bodyLargeStrong'
            break
        case 'heading2':
            descriptionVariant = 'body'
            currencyVariant = currencySize || 'bodyStrong'
            break
        case 'heading4':
            descriptionVariant = 'bodyExtraSmall'
            currencyVariant = currencySize || 'bodyExtraSmallStrong'
            break
        case 'bodyExtraSmall':
            descriptionVariant = 'bodyExtraSmall'
            currencyVariant = currencySize || 'bodyExtraSmall'
            break
    }

    const perText =
        per &&
        (per === 'person'
            ? formatMessage({
                  id: 'global.price.label_single_person',
                  defaultMessage: '/os.',
              })
            : formatMessage({
                  id: 'global.price.label_couple',
                  defaultMessage: '/2 os.',
              }))

    const totalPrice = () => {
        if (value === null) return '-'

        if (value === 0) {
            return 0
        } else if (value > 0) {
            return formatPrice(value)
        } else {
            return '-'
        }
    }

    return (
        <Wrapper
            direction="row"
            align="baseline"
            gap={4}
            crossedOutVariant={crossedOutVariant}
        >
            {!!description && (
                <Text
                    variant={descriptionSize || descriptionVariant}
                    color={color || 'secondary_500'}
                    isCapitalized={isCapitalized}
                >
                    {description}
                </Text>
            )}
            <Text variant={size} color={color || 'secondary_500'}>
                {isNegative && '- '}
                {totalPrice()}
            </Text>
            <Text
                variant={currencySize || currencyVariant}
                color={color || 'secondary_500'}
                hasNoWrap={true}
            >
                PLN{perText}
            </Text>
        </Wrapper>
    )
}

export default Price
